import { apiDelete, apiGet, apiPost, apiPut } from './api';

export async function getAllBlogs() {
  const result = await apiGet('/blogs');
  return result.data || [];
}

export async function getBlogById(id) {
  const result = await apiGet(`/blogs/${id}`);
  return result.data || null;
}

export async function saveCustomBlog(blog) {
  const payload = {
    ...blog,
    date: blog.date || new Date().toISOString().split('T')[0],
    tags: parseTags(blog.tags, blog.category),
  };
  const result = await apiPost('/blogs', payload);
  return result.data;
}

export async function updateBlog(id, data) {
  const payload = {
    ...data,
    tags: parseTags(data.tags, data.category),
  };
  const result = await apiPut(`/blogs/${id}`, payload);
  return result.data;
}

export async function deleteBlog(id) {
  await apiDelete(`/blogs/${id}`);
}

/** @deprecated use deleteBlog */
export async function deleteCustomBlog(id) {
  return deleteBlog(id);
}

export function formatBlogDate(dateStr) {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleDateString('tr-TR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

export function formatSidebarDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  const months = ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'];
  return `${d.getDate()} / ${months[d.getMonth()]}`;
}

export function getCategories(blogs) {
  const counts = {};
  blogs.forEach((b) => {
    counts[b.category] = (counts[b.category] || 0) + 1;
  });
  return Object.entries(counts).map(([name, count]) => ({ name, count }));
}

export function isCustomBlog(id) {
  return !String(id).startsWith('default-');
}

function parseTags(tags, category) {
  if (Array.isArray(tags)) return tags;
  if (typeof tags === 'string' && tags.trim()) {
    return tags.split(',').map((t) => t.trim()).filter(Boolean);
  }
  return [category || 'Genel'];
}

export function blogToForm(blog) {
  return {
    title: blog.title || '',
    titleHighlight: blog.titleHighlight || '',
    excerpt: blog.excerpt || '',
    content: blog.content || '',
    coverImg: blog.coverImg || '',
    category: blog.category || '',
    author: blog.author || 'Admin',
    date: blog.date || '',
    tags: Array.isArray(blog.tags) ? blog.tags.join(', ') : '',
  };
}

const emptyForm = {
  title: '',
  titleHighlight: '',
  excerpt: '',
  content: '',
  coverImg: '',
  category: '',
  author: 'Admin',
  date: '',
  tags: '',
};

export { emptyForm };
